export default __webpack_public_path__ + "static/media/home-digital-agency-img-05.5d8fb78e.jpg";